import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../../services/dataservice.service';
import { Subscription} from 'rxjs';

@Component({
  selector: 'app-right-side',
  templateUrl: './right-side.component.html',
  styleUrls: ['./right-side.component.scss']
})
export class RightSideComponent implements OnInit {
  checked = true;
  defaultOutput: any;
  observable: Subscription;
  textResult: any;
  classificationCheckbox: any;
  result: any;
  color = 'primary';
  timings = [3000, 5000, 2000, 1500, 2200, 2200];
  audioTimings = [80, 70, 100, 100, 100, 100];
  Classification = [
    { key: 'STOCK', color: '#ff5252'},
    { key: 'PRICE', color: '#40C4FF'},
    { key: 'TRADE NUMBER', color: '#2ab0b9'},
    { key: 'QUANTITY', color: '#FF6E40'},
    { key: 'TIME', color: '#FFD740'},
    { key: 'ACTION', color: '#33FFBD'},
  ];
  deSelectedLabels: any;
  selectedLabels: any;
  loader: any;
  index: any;
  resultData = ['<span class=\"six\">Long </span><span class=\"four\">100 shares</span> of <span class=\"one\">TCS</span> at <span class=\"two\">market order</span>.',
  '<span class=\"six\">Bought</span> <span class="one">TCS</span> <span class="four">100 shares</span>at<span class=\"two\"> 2200</span>, <span class=\"three\">Trade No: 550</span>,<span class=\"five\">Trade time: 09:20 AM</span> , Order No: 776, Net debit of <span class=\"two\">220000</span>',
  '<span class=\"six\">Square off</span> <span class=\"four\">1 lot</span> of <span class=\"one"\/>PNB</span> <span class=\"two\">52 put</span> of <span class=\"one\">current expiry</span>.',
  '<span class=\"six\">Sold</span> <span class=\"one\">PNB</span> <span class=\"\">put option</span> of <span class=\"one\">March expiry</span> at <span class=\"two\">2.5</span> at <span class=\"five\">10:00 AM</span>, order no: 662, <span class=\"three\">trade no: 558</span>',
  'Place <span class=\"four\">1</span> <span class=\"six\">sell</span> limit order <span class=\"one\">NIFTY futures March expiry</span> at <span class=\"two\">9800</span> with SL of <span class=\"two\">10200</span> and target of <span class=\"two\">9100</span>.',
  '<span class=\"six\">Sold</span> <span class=\"one\">Zinc March futures</span> at <span class=\"two\">157</span>, <span class=\"three\">Trade No: 778</span>, Order No: 455'];
  constructor(private dataservice: DataserviceService) { }

  ngOnInit() {
    this.deSelectedLabels = [];
    this.textResult = true;
    this.classificationCheckbox = false;
    this.selectedLabels = [
      'STOCK', 'PRICE', 'TRADE NUMBER', 'QUANTITY', 'TIME', 'ACTION'
    ];
    this.observable = this.dataservice.message.subscribe((data) => this.loadData(data));
  }
  loadData(data) {
    if (data['value'] === 9) {
      this.textResult = true;
      this.classificationCheckbox = false;
      this.loader = true;
      this.result = '';
    } else {
      this.textResult = false;
      this.loader = false;
      this.classificationCheckbox = true;
      this.result = this.resultData[data['value']];
    }
  }
  selectLabel(label: string) {
    console.log('label ' +label);
    const index1 = this.selectedLabels.indexOf(label);
    if (index1 === -1) {
      this.selectedLabels.splice(index1, 1);
    } else {
      this.selectedLabels.push(label);
    }
    for (let i = 0; i < this.selectedLabels.length; i++) {
      console.log('Selected label ' + this.selectedLabels[i]);
      switch (this.selectedLabels[i]) {
        case 'STOCK': {
          const temp = JSON.stringify(this.result).replace(new RegExp('/one/', 'g'), 'one');
          console.log(temp);
          this.result = JSON.parse(temp);
          break;
        }
        case 'PRICE': {
          const temp = JSON.stringify(this.result).replace(new RegExp('/two/', 'g'), 'two');
          console.log(temp);
          this.result = JSON.parse(temp);
          break;
        }
        case 'TRADE NUMBER': {
          const temp = JSON.stringify(this.result).replace(new RegExp('/three/', 'g'), 'three');
          console.log(temp);
          this.result = JSON.parse(temp);
          break;
        }
        case 'QUANTITY': {
          const temp = JSON.stringify(this.result).replace(new RegExp('/four/', 'g'), 'four');
          console.log(temp);
          this.result = JSON.parse(temp);
          break;
        }
        case 'TIME': {
          const temp = JSON.stringify(this.result).replace(new RegExp('/five/', 'g'), 'five');
          this.result = JSON.parse(temp);
          console.log(temp);
          break;
        }
        case 'ACTION': {
          const temp = JSON.stringify(this.result).replace(new RegExp('/six/', 'g'), 'six');
          this.result = JSON.parse(temp);
          console.log(temp);
          break;
        }
        default: {
          this.result = this.defaultOutput;
          this.selectedLabels = [];
          break;
        }
      }
    }

    const index = this.deSelectedLabels.indexOf(label);
    if (index === -1) {
      this.deSelectedLabels.push(label);
    } else {
      this.deSelectedLabels.splice(index, 1);
    }
    for (let i = 0; i < this.deSelectedLabels.length; i++) {
      switch (this.deSelectedLabels[i]) {
        case 'STOCK': {
          const temp = JSON.stringify(this.result).replace(new RegExp('one', 'g'), '/one/');
          this.result = JSON.parse(temp);
          break;
        }
        case 'PRICE': {
          const temp = JSON.stringify(this.result).replace(new RegExp('two', 'g'), '/two/');
          this.result = JSON.parse(temp);
          break;
        }
        case 'TRADE NUMBER': {
          const temp = JSON.stringify(this.result).replace(new RegExp('three', 'g'), '/three/');
          this.result = JSON.parse(temp);
          break;
        }
        case 'QUANTITY': {
          const temp = JSON.stringify(this.result).replace(new RegExp('four', 'g'), '/four/');
          this.result = JSON.parse(temp);
          break;
        }
        case 'TIME': {
          const temp = JSON.stringify(this.result).replace(new RegExp('five', 'g'), '/five/');
          this.result = JSON.parse(temp);
          break;
        }
        case 'ACTION': {
          const temp = JSON.stringify(this.result).replace(new RegExp('six', 'g'), '/six/');
          this.result = JSON.parse(temp);
          break;
        }
        default: {
          this.result = this.defaultOutput;
          this.deSelectedLabels = [];
          break;
        }
      }
    }
  }

}
